import React from 'react'
import { Card } from '../Card'
import { Skeleton } from '../Skeleton'

export interface RecipeCardSkeletonProps {
  /**
   * Number of badge skeletons to show
   */
  badgeCount?: number

  /**
   * Whether to show the detailed view skeleton
   */
  showDetails?: boolean

  /**
   * Custom className for the card container
   */
  className?: string
}

export const RecipeCardSkeleton: React.FC<RecipeCardSkeletonProps> = ({
  badgeCount = 3,
  showDetails = false,
  className
}) => {
  return (
    <Card variant="default" padding="md" className={className}>
      {/* Header */}
      <div className="flex items-start justify-between mb-3">
        {/* Recipe name */}
        <Skeleton variant="text" className="flex-1" height={20} />

        {/* Action buttons */}
        <div className="flex items-center space-x-2 ml-3">
          <Skeleton variant="circular" width={28} height={28} />
          <Skeleton variant="circular" width={28} height={28} />
        </div>
      </div>

      {/* Modifiable badges */}
      <div className="flex flex-wrap gap-2 mb-3">
        {Array.from({ length: badgeCount }).map((_, index) => (
          <Skeleton
            key={index}
            variant="rounded"
            width={80}
            height={24}
          />
        ))}
      </div>

      {/* Optional detailed view */}
      {showDetails && (
        <div className="mt-4 space-y-3 border-t pt-4">
          {/* Ingredients section */}
          <div className="space-y-2">
            <Skeleton variant="text" width="40%" height={16} />
            <Skeleton variant="text" width="100%" height={12} />
            <Skeleton variant="text" width="90%" height={12} />
            <Skeleton variant="text" width="95%" height={12} />
          </div>

          {/* Instructions section */}
          <div className="space-y-2">
            <Skeleton variant="text" width="50%" height={16} />
            <Skeleton variant="text" width="100%" height={12} />
            <Skeleton variant="text" width="100%" height={12} />
            <Skeleton variant="text" width="85%" height={12} />
          </div>
        </div>
      )}
    </Card>
  )
}

RecipeCardSkeleton.displayName = 'RecipeCardSkeleton'

export default RecipeCardSkeleton
